import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListagemReceitas from "./components/ListagemReceitas/index";

function RelatorioReceitasPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Relatório de receita",
      url: "/relatorios/financeiro/receitas",
    },
  ]);

  return (
    <>
      <Container>
        <ListagemReceitas />
      </Container>
    </>
  );
}

export default RelatorioReceitasPage;
